import Form from 'react-bootstrap/Form';
import * as CommonUtilities from "../../../common/utils/CommonUtils.js";

export default function CartProduct(props) {
    let productDisplay;
    let originalTotalPriceInc = <></>;
    const qtyOptions = [...Array(30)].map((item, index) => <option key={index + 1}>{index + 1}</option>)
    
    if (props.data.itemUsageTypeID === 1) { // Item Usage Type ID: 1 = Regular, 2 = Product Combo
        let modifiers;
        if (props.data.mods !== null) {
            modifiers =  props.data.mods.length > 0 && props.data.mods.map((mod) => {
                let modifierPriceInc = CommonUtilities.formatDisplayPrice(mod.priceInc);
                if (mod.itemUsageTypeName === "Regular") {
                    return (
                        <small key={mod.recID} className="col-12 text-muted">
                            <span>{mod.modName}</span><span className="ms-2 ps-1">{modifierPriceInc}</span>
                        </small>
                    )
                } else if (mod.itemUsageTypeName === "Combo") { // Modifier Combo in Regular Product
                    let modsInComboWrapper, modsInCombo = <></>
                    if (mod.modsInCombo.length > 0) {
                        let modInComboListKey = -1;
                        modsInCombo = mod.modsInCombo.map((modInCombo) => {
                            modInComboListKey += 1;
                            let modInComboPriceInc = CommonUtilities.formatDisplayPrice(modInCombo.priceInc);
                            return (
                                <li key={modInComboListKey}>{modInCombo.modName}<span className="ms-2 ps-1">{modInComboPriceInc}</span></li>
                            )
                        })
                        modsInComboWrapper = <ul className="mb-0">{modsInCombo}</ul>
                    }
                    return (
                        <small key={mod.recID} className="col-12 text-muted">
                            <span>{mod.modName}</span><span className="ms-2 ps-1">{modifierPriceInc}</span>
                            {modsInComboWrapper}
                        </small>
                    )
                }
            });
        }

        let fontWeight;
        if (props.data.productPLU === 999999000) { // Surcharge
            fontWeight = "fw-normal";
        } else {
            fontWeight = "fw-bold";
        }
        // === begin: Bulk Pricing - Regular Product ===
        let unitPriceWrapper = <></>;
        if (CommonUtilities.StaticFields.PriceType == 'bp8826') {
            // Total Price
            if (props.data.originalPriceTotalInc > props.data.priceTotalInc) {
                originalTotalPriceInc = <><span className="text-decoration-line-through text-muted">{CommonUtilities.StaticFields.CurrencySymbol}{(props.data.originalPriceTotalInc).toFixed(2)}</span><br /></>
            }
            // Unit Price
            if (props.data.originalPrice > props.data.priceInc) {
                unitPriceWrapper = <small className="text-muted bg-secondary-subtle py-1 px-2 rounded d-flex flex-row gap-2 flex-wrap">
                                        <span className="text-decoration-line-through">{CommonUtilities.StaticFields.CurrencySymbol}{(props.data.originalPrice).toFixed(2)} each</span><span>{CommonUtilities.StaticFields.CurrencySymbol}{(props.data.priceInc).toFixed(2)} each</span>
                                    </small>
            } 
        }
        // === end: Bulk Pricing - Regular Product ===
        
        // Regular Product Display
        productDisplay = <div className="d-flex flex-column justify-content-start text-break">
                            <div className="gap-2 d-flex flex-sm-row flex-column"><span className={fontWeight}>{props.data.productName}</span>{unitPriceWrapper}</div>
                            {modifiers}
                            {props.data.specialInstructions && <div className="col-12"><small className="text-secondary"><span className="fw-medium">Note:</span> {props.data.specialInstructions}</small></div>}
                        </div>
    } else if (props.data.itemUsageTypeID === 2) { // Item Usage Type ID: 1 = Regular, 2 = Combo
        const productsInCombo = props.data.productsInCombo.length > 0 && props.data.productsInCombo.map((item) => {
            let modifierDisplayContainer, modifiersToDisplay;
            if (item.mods.length > 0) {
                modifiersToDisplay = item.mods.map((modItem) => {
                    let modifierPriceInc = "";
                    if (modItem.priceInc !== 0 && modItem.priceInc !== "0") {
                        if ((modItem.priceInc).toString().charAt(0) !== "") {
                            if ((modItem.priceInc).toString().charAt(0) === "-") {
                                modifierPriceInc = "-" + CommonUtilities.StaticFields.CurrencySymbol + (parseFloat(modItem.priceInc).toFixed(2)).toString().slice(1);
                            } else {
                                modifierPriceInc = CommonUtilities.StaticFields.CurrencySymbol + parseFloat(modItem.priceInc).toFixed(2);
                            }
                        }
                    }
                    return <li key={modItem.recID}>{modItem.modName}<span className="ms-2 ps-1">{modifierPriceInc}</span></li>
                });
                modifierDisplayContainer = 
                    <small className="text-muted">
                        <ul className="mb-0">
                            {modifiersToDisplay}
                        </ul>
                    </small>
            } else {
                modifierDisplayContainer = <></>;
            }
            
            return (
                <div key={item.recID} className="col-12 mb-2 pb-1">
                    <span className="text-secondary">{item.productName}</span>
                    {modifierDisplayContainer}
                    {item.specialInstructions && <div className="col-12"><small className="text-secondary"><span className="fw-medium">Note:</span> {item.specialInstructions}</small></div>}
                </div>
            )
        })

        // === begin: Bulk Pricing - Product Combo ===
        let unitPriceWrapper = <></>;
        if (CommonUtilities.StaticFields.PriceType == 'bp8826') {
            // Total Price
            if (props.data.originalPriceTotalInc > props.data.priceTotalInc) {
                originalTotalPriceInc = <><span className="text-decoration-line-through text-muted">{CommonUtilities.StaticFields.CurrencySymbol}{(props.data.originalPriceTotalInc).toFixed(2)}</span><br /></>
            }
            // Unit Price
            if (props.data.originalPrice > props.data.priceInc) {
                unitPriceWrapper = <small className="text-muted bg-secondary-subtle py-1 px-2 rounded d-flex flex-row gap-2 flex-wrap">
                                        <span className="text-decoration-line-through">{CommonUtilities.StaticFields.CurrencySymbol}{(props.data.originalPrice).toFixed(2)} each</span><span>{CommonUtilities.StaticFields.CurrencySymbol}{(props.data.priceInc).toFixed(2)} each</span>
                                    </small>
            }
        } 
        // === end: Bulk Pricing - Product Combo ===

        // Product Combo Display
        productDisplay = <div className="d-flex flex-column justify-content-start text-break">
                            <div className="gap-2 d-flex flex-sm-row flex-column"><b>{props.data.productName}</b>{unitPriceWrapper}</div>
                            {productsInCombo}
                        </div>
    }

    let formSelect, removeBtn;
    if (props.data.productPLU === 999999000) { // Surcharge
        formSelect = <span style={{width: "65px"}}></span>
        removeBtn = <></>
    } else {
        formSelect = <Form.Select size="sm" style={{width: "65px"}} className="rounded-pill bg-light" onChange={props.handleQuantityChange} value={props.data.quantity} data-productrecid={props.data.recID} disabled={props.cartError.ButtonsDisabled}>
                        {qtyOptions}
                    </Form.Select>
        removeBtn = <a className="link-primary link-underline link-underline-opacity-0 link-offset-2 link-underline-opacity-50-hover" href="#" onClick={!props.cartError.ButtonsDisabled ? props.handleRemoveProdFromCart : undefined} data-productrecid={props.data.recID}>Remove</a>
    }
    
    return (
        props.data.productPLU === 999999010 ? // Service Fee PLU - Skip if as this will be displayed next to the subtotal
        <></> 
        :
        <div className="col-12 row p-0 m-0">
            <div className="col-8 d-flex align-items-start gap-2 gap-sm-3">
                {formSelect}
                {productDisplay}
            </div>
            <div className="col-4 text-end">
                <span className="fw-bold">{CommonUtilities.StaticFields.CurrencySymbol}{(props.data.priceTotalInc).toFixed(2)}</span><br />
                {originalTotalPriceInc}
                {removeBtn}
            </div>
            <div className="col-12">
                <hr className="text-body-tertiary" />
            </div>
        </div>
    )
}